import React from 'react';

const PageFooter = () => {
  return <div>Intelligent Buildings, LLC</div>;
};

export default PageFooter;
